export default __webpack_public_path__ + "static/media/brand-twitter-new.c9d69acf.png";